import { cva, type VariantProps } from 'class-variance-authority';

export const rankingCardVariants = cva(
  'bg-white rounded-lg border border-neutral-200 shadow-xs overflow-hidden grid gap-lg px-info-card-med-sides py-info-card-med-top-bottom',
);

export type RankingCardVariantProps = VariantProps<typeof rankingCardVariants>;

// size-[60px]: Figma spec requires fixed 60px at all breakpoints; the size-3xl token is responsive and shrinks on mobile
export const rankBadgeVariants = cva(
  'flex-shrink-0 flex justify-center items-center size-[60px] border rounded-md',
  {
    variants: {
      variant: {
        ranked: 'text-heading bg-secondary-50 border-secondary-700 font-bold',
        unranked: 'hidden',
      },
    },
    defaultVariants: {
      variant: 'ranked',
    },
  },
);

export type RankBadgeVariantProps = VariantProps<typeof rankBadgeVariants>;

export const expandContentVariants = cva(
  'grid overflow-hidden transition-all duration-slow ease-in-out',
  {
    variants: {
      expanded: {
        true: 'grid-rows-[1fr] opacity-100',
        false: 'grid-rows-[0fr] opacity-0',
      },
    },
    defaultVariants: {
      expanded: false,
    },
  },
);

export type ExpandContentVariantProps = VariantProps<
  typeof expandContentVariants
>;
